import { PortalIcon, type PortalIconProps } from './portal-icon';

/** Me — person silhouette for the Me tab. */
export function MeIcon(props: PortalIconProps) {
  return (
    <PortalIcon {...props}>
      <circle cx="12" cy="8" r="3.4" />
      <path d="M5.5 19.5a6.5 6.5 0 0 1 13 0" />
    </PortalIcon>
  );
}
